<div class="card">
  <h4 class="card-header">Login</h4>
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
     

      <div class="form-group">

        <ngx-recaptcha2 #captchaElem
                        [siteKey]="siteKey" formControlName="recaptcha">

        </ngx-recaptcha2>
      </div>
      <div class="form-group">
        <button [disabled]="loading" class="btn btn-primary">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Login
        </button>
      </div>
    </form>
  </div>
</div>
